import { TokenUserPayload } from '@/core/models/token.model'
import { Injectable, inject } from '@angular/core'
import { JwtService } from './jwt.service'
@Injectable({
	providedIn: 'root',
})
export class TokenStorageService {
	private readonly jwtService = inject(JwtService)
	setToken(key: string, token: string): void {
		localStorage.setItem(key, token)
	}
	getToken(key: string): string {
		return localStorage.getItem(key) ?? ''
	}
	removeToken(key: string): void {
		localStorage.removeItem(key)
	}
	storeTokensFromParams(params: Record<string, string>): TokenUserPayload {
		for (const key of ['access_token', 'id_token', 'refresh_token', 'tokenUser']) {
			if (params[key]) {
				this.setToken(key, params[key])
			}
		}
		const tokenUser = params['tokenUser']
		if (!tokenUser) {
			throw new Error('tokenUser parameter is required')
		}
		const decoded = this.jwtService.decodeToken(tokenUser)
		if (!decoded) {
			throw new Error('Failed to decode tokenUser')
		}
		localStorage.setItem('userPayload', JSON.stringify(decoded))
		return decoded
	}
	getUserPayload(): TokenUserPayload {
		const data = localStorage.getItem('userPayload')
		if (!data) {
			throw new Error('User payload not found in localStorage')
		}
		return JSON.parse(data)
	}
	clearAll(): void {
		for (const key of ['tokenUser', 'selectedAccount', 'userPayload', 'access_token', 'id_token', 'refresh_token']) {
			localStorage.removeItem(key)
		}
	}
}
